<template>
  <div class="my-reading-level-view">
    <div class="text-block">
      <div class="text-block-title">
        <div class="icon-bg">
          <BaseSpriteIcon icon-name="ico-task-line" />
        </div>
        <div>{{ $t('MyRedingLevel.title.label') }}</div>
      </div>
      <div class="text-block-stats my-4">
        <div v-for="(item, index) in stats" :key="index" class="stats-item">
          <div class="stats-label">{{ item.label }}</div>
          <div class="stats-value">{{ item.value }}</div>
        </div>
      </div>
    </div>
    <div class="controls-block">
      <div class="my-2">
        <BaseButton
          color="primary"
          block
          large
          elevation="0"
          @click="toAssessment"
        >
          {{ $t('MyRedingLevel.button.label') }}
        </BaseButton>
      </div>
      <div class="info-block mt-2" style="display: none">
        <BaseSpriteIcon icon-name="ico-info" color="#FC6539" />
        <div>{{ $t('MyRedingLevel.description.label') }}</div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import dayJS from '@/dayJS';
import AssessmentTypes from '@/enums/AssessmentTypes';
import AppStateEnum from '@/enums/AppStateEnum';
import BaseButton from '@/components/base/BaseButton/BaseButton';
import BaseSpriteIcon from '@/components/base/BaseSpriteIcon/BaseSpriteIcon';

export default {
  name: 'MyRedingLevel',
  components: { BaseButton, BaseSpriteIcon },
  computed: {
    ...mapGetters('ProgressStore', ['getMinutesPassedInSuggestionSet']),
    ...mapGetters('AssessmentStore', [
      'getLatestCompletedResult',
      'isSuggestedAssessmentButtonVisible'
    ]),
    stats() {
      const lastResult = this.getLatestCompletedResult || {};
      return [
        {
          label: this.$t('MyRedingLevel.current.label'),
          value: Math.floor(lastResult.bookLevel * 10) / 10 || 0
        },
        {
          label: this.$t('MyRedingLevel.mastery.label'),
          value: lastResult.masteryLevel || 0
        },
        {
          label: this.$t('MyRedingLevel.total.label'),
          value: this.humanizeDuration(this.getMinutesPassedInSuggestionSet)
        }
      ];
    }
  },
  async mounted() {
    this.$store.dispatch('AssessmentStore/initAssessmentStore', {
      testType: AssessmentTypes.VOCABULARY_ASSESSMENT
    });
    await this.$store.dispatch('AssessmentStore/initLatestResult');
    await this.$store.dispatch('AssessmentStore/fetchAllUserResults');
    await this.$store.dispatch('ProgressStore/retrieveSuggestionsProgress');
  },
  methods: {
    humanizeDuration(minutes = 0) {
      const duration = dayJS.getDuration(minutes * 60 * 1000);
      return this.$t('MyActivity.read.time', {
        hours: duration.hours(),
        minutes: duration.minutes()
      });
    },
    toAssessment() {
      this.$router.push({
        name: AppStateEnum.ASSESSMENT
      });
    }
  }
};
</script>

<style lang="less">
.my-reading-level-view {
  border: 1px solid #cbd5e1;
  border-radius: 20px;
  padding: 20px;
  display: flex;
  flex-direction: column;

  .text-block {
    flex-grow: 1;
    display: flex;
    flex-direction: column;

    .text-block-title {
      flex-shrink: 0;
      display: flex;
      align-items: center;
      gap: 8px;
      font-weight: 700;
      font-size: 20px;
      line-height: 30px;

      .icon-bg {
        width: 36px;
        height: 36px;
        background: var(--primary-color);
        display: flex;
        justify-content: center;
        align-items: center;
        border-radius: 18px;

        svg {
          fill: #fff;
        }
      }
    }

    .text-block-stats {
      flex-grow: 1;
      display: flex;
      flex-direction: column;
      justify-content: center;
      gap: 8px;
      font-weight: 500;
      font-size: 16px;
      line-height: 26px;

      .stats-item {
        display: flex;
        justify-content: space-between;
        align-items: center;
        gap: 8px;

        .stats-value {
          font-weight: 700;
        }
      }
    }
  }

  .info-block {
    background: #f1f5f9;
    border-radius: 7px;
    padding: 12px;
    display: flex;
    align-items: center;
    gap: 8px;
    font-weight: 500;
    font-size: 14px;
    line-height: 20px;

    svg {
      flex-shrink: 0;
    }
  }
}
</style>
